import React from 'react';
import ServiceCard01 from '../../Components/ServiceCards/ServiceCard01';

const ServiceHome01 = () => {
    const ServiceData = [
        {
            id: '1',
            img: 'images/services/s8.png',
            img02: 'images/services/ss1.png',
            path: '/ristrutturazione',
            bg: 'bg_3',
            title: 'Servizi di ristrutturazione'
        },
        {
            id: '2',
            img: 'images/services/s2.png',
            img02: 'images/services/ss2.png',
            path: 'costruzione-chiavi-in-mano',
            bg: 'bg_2',
            title: 'Costruzione residenziale'
        },
        {
            id: '3',
            img: 'images/services/s3.png',
            img02: 'images/services/sbg3.png',
            path: 'movimenti-di-terra',
            bg: 'bg_3',
            title: 'Movimenti di terra'
        }
    ];

    return (
        <div className="service">
            <div className="container-fluid g-0">
                <div className="row g-0">
                    {
                        ServiceData.map(data =>
                            <ServiceCard01
                                key={data.id}
                                data={data}
                            />
                        )
                    }
                </div>
                <div className="row g-0">
                    <div className="col col-lg-12">
                        <div className="service-content text-center">
                           {/* <h1 className="section_title">Servizi di ristrutturazione</h1> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceHome01;